import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const HOT_TAKE: WidgetPreset = {
  id: "hot-take",
  label: "Hot Take 🔥",
  defaultWidth: 160,
  defaultHeight: 48,
  html: templateHtml,
};
